import { TrSpace } from "../components/TrSpace";
import { FormPageButton } from "../components/FormPageButton";
import { Link } from 'react-router-dom';
import { TrWidthFullText } from "../components/TrWidthFullText";

export const PrivacyPolicy = () => {
    return (
        <div className='flex flex-col min-h-screen'>
                <main className="flex-grow">
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>プライバシポリシー</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table className="w-fit">
                            <tbody>
                                <TrWidthFullText text="当サービスをご利用するお客様のプライバシーに係る個人情報の重要性を認識し、適切に利用し、個人情報の保護に努めることをお約束します。" isBold={false}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrWidthFullText text="個人情報の利用目的" isBold={true}/>
                                <TrWidthFullText text="当サービスでは、メールでのお問い合わせの際に、名前、メールアドレス等の個人情報を送信いただきますが、これらの個人情報は質問に対する回答や必要な情報を電子メールなどでご連絡する場合に利用させていただくものであり、個人情報をご提供いただく際の目的以外では利用いたしません。"/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrWidthFullText text="個人情報の第三者への開示" isBold={true}/>
                                <TrWidthFullText text="当サービスでは、個人情報は適切に管理し、以下に該当する場合を除いて第三者へ開示することはありません。" isBold={false}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrWidthFullText text="・情報提供者本人の同意がある場合" isBold={false}/>
                                <TrWidthFullText text="・法令等への協力のため、開示が必要な場合" isBold={false}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrWidthFullText text="個人情報の訂正、削除について" isBold={true}/>
                                <TrWidthFullText text="ご利用者様ご本人の要請があった場合、ご本人を確認した上で個人情報の訂正、削除を適切に行います。" isBold={false}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrWidthFullText text="個人情報保護に関するお問い合わせ" isBold={true}/>
                                <TrWidthFullText text="個人情報保護に関するお問い合わせや開示、修正、削除のご依頼がある場合は、お問い合わせフォームよりご連絡ください。" isBold={false}/>
                                <TrSpace/>
                                <TrSpace/>
                            </tbody>
                        </table>
                        <Link to="/">
                            <FormPageButton text="ホームへ戻る"/>
                        </Link>
                    </div>
                </main>
        </div>
    );
};